/* eslint-disable no-unused-vars */
import React, { Dispatch, SetStateAction, useMemo } from 'react'
import { Calendar } from 'antd'
import styles from '../SAPPCalendarFilter.module.css'
import {
  EducationIcon,
  EyeIcon,
  GoldStarIcon,
  HiddenEyeIcon,
  TagIcon,
  TestIcon
} from '../../../icons'
import { ICourse, IFilter } from '../../../types'
import { Dayjs } from 'dayjs'
import { LEARNING_MODE } from '../../../constants'
import FlagIcon from '../../../icons/FlagIcon'

interface IProps {
  filter: IFilter
  setFilter: Dispatch<SetStateAction<IFilter>>
  courses?: ICourse[]
  onRefetchAPI: (filterDate: Date) => void
}

const FilterCalendar = ({
  filter,
  setFilter,
  courses,
  onRefetchAPI
}: IProps) => {
  const noteFilter = useMemo(
    () => [
      {
        title: 'Online',
        icon: <div className={styles['calendar-filter_note_blue']} />,
        value: LEARNING_MODE.ONLINE
      },
      {
        title: 'Live Online',
        icon: <div className={styles['calendar-filter_note_pureple']} />,
        value: LEARNING_MODE.LIVE_ONLINE
      },
      {
        title: 'Offline',
        icon: <div className={styles['calendar-filter_note_green']} />,
        value: LEARNING_MODE.OFFLINE
      },
      { title: 'Test', icon: <TestIcon />, value: LEARNING_MODE.TEST },
      {
        title: 'Case Study',
        icon: <GoldStarIcon />,
        value: LEARNING_MODE.CASE_STUDY
      },
      {
        title: 'Key Content Of',
        icon: <FlagIcon />,
        value: LEARNING_MODE.KEY_BEFORE_CONTENT
      },
      {
        title: 'Holiday',
        icon: <div className={styles['calendar-filter_note_yellow']} />,
        value: LEARNING_MODE.HOLIDAY
      },
      {
        title: 'Overdue',
        icon: <div className={styles['calendar-filter_note_red']} />,
        value: LEARNING_MODE.OVERDUE
      }
    ],
    []
  )
  const handleFilter = (type: string, value: string) => {
    switch (type) {
      case 'course': {
        setFilter((prev: IFilter) => {
          const courseId = prev.courseId || []
          const updatedCourseId = courseId.includes(value)
            ? courseId.filter((item) => item !== value)
            : [...courseId, value]
          return { ...prev, courseId: updatedCourseId }
        })
        break
      }
      case 'note': {
        setFilter((prev: IFilter) => {
          const typeArray = prev.type || []
          const updatedType = typeArray.includes(value)
            ? typeArray.filter((item) => item !== value)
            : [...typeArray, value]
          return { ...prev, type: updatedType }
        })
        break
      }
      case 'day': {
        setFilter((prev: IFilter) => {
          return { ...prev, day: value }
        })
        break
      }
    }
  }

  const handleFilterday = (date: Dayjs) => {
    onRefetchAPI(date.toDate())
    handleFilter('day', date.toString())
  }
  return (
    <div className={styles['calendar-filter']}>
      <Calendar
        mode='month'
        className={styles['custom-today-picker']}
        fullscreen={false}
        onChange={handleFilterday}
      />
      <div>
        <div className={styles['calendar-filter_title']}>
          <TagIcon />
          <h3>Notes</h3>
        </div>
        <div>
          {noteFilter.map((item) => {
            return (
              <div
                className={styles['calendar-filter_content_list_item']}
                key={item.value}
              >
                <div className={styles['calendar-filter_content_list_item']}>
                  {item.icon}
                  {item.title}
                </div>
                <div
                  onClick={() => handleFilter('note', item.value)}
                  className={styles['calendar-filter_content_item_eye']}
                >
                  {filter.type?.includes(item.value) ? (
                    <EyeIcon />
                  ) : (
                    <HiddenEyeIcon />
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div>
        <div className={styles['calendar-filter_title']}>
          <EducationIcon />
          <h3>My courses</h3>
        </div>
        <div>
          {courses?.map((item, key) => {
            return (
              <div
                key={key}
                className={styles['calendar-filter_content_list_item']}
              >
                <div className={styles['calendar-filter_content_list_item']}>
                  {item.name}
                </div>
                <div
                  onClick={() => handleFilter('course', item.id)}
                  className={styles['calendar-filter_content_item_eye']}
                >
                  {filter.courseId?.includes(item.id) ? (
                    <EyeIcon />
                  ) : (
                    <HiddenEyeIcon />
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default FilterCalendar
